import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { catchError, Observable } from 'rxjs';
import {  throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { buildAetUserContext } from '../core/constant/user-context.util';
@Injectable({
  providedIn: 'root'
})
export class ControlPointService {

  baseURL = environment.baseAPIURL;

  constructor( private readonly http  : HttpClient) { }

  getSnapshotsForDate(snapShotDate: any) {
    return this.http.get(`${this.baseURL}/getSnapshotsForDate/${snapShotDate}`, { responseType: 'json' }
    ).pipe(catchError(this.handleError));
  }

  fetchCPMDashboardData() {
    return this.http.get(`${this.baseURL}/controlPointMatrix/fetchCPMDashboardData`, { responseType: 'json' }
    ).pipe(catchError(this.handleError));
  }

  loadDomiciles() {
    return this.http.get(`${this.baseURL}/controlPointMatrix/loadDomiciles`, { responseType: 'json' }
    ).pipe(catchError(this.handleError));
  }

  fetchCPMComments(_id:any) {
    return this.http.get(`${this.baseURL}/controlPointMatrix/fetchCPMComments/20`, { responseType: 'json' }
    )
      .pipe(catchError(this.handleError));
  }

  statsData(plantCode, date): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('selectedLogPt', plantCode)
    formData.append('statsStartDate', date)
    return this.http.post(`${this.baseURL}/fetchCPMStatsData`, formData, { responseType: 'json' }
    ).pipe(catchError(this.handleError));
  }

  getUpdateCriteria(plantCode) {
    return this.http.get(`${this.baseURL}/cpm/fetchCPMThreshold/${plantCode}`, { responseType: 'json' }
    ).pipe(catchError(this.handleError));
  }

  putUpdateCriteria(data) {
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const displayName = fgaDetails?.user?.displayName;
    const rb = { event: data, userReqDto: buildAetUserContext() };
    return this.http.put(`${this.baseURL}/cpm/updateCPMThreshold/${displayName}`, rb, { responseType: 'json' }).pipe(catchError(this.handleError));
  }

  updateCPMDashboard(responseBody){
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const displayName = fgaDetails?.user?.displayName;
    const rb = { event: responseBody, userReqDto: buildAetUserContext() };
    return this.http.post(`${this.baseURL}/cpm/updateCPMDashboard/${displayName}`, rb, { responseType: 'json' }).pipe(catchError(this.handleError));
  }

  fetchCPMDashboardDataDropdown(id) {
    return this.http.get(`${this.baseURL}/cpm/fetchCPMDashboardData/${id}`, { responseType: 'json' }
    ).pipe(catchError(this.handleError));
  }
  
  exportCPMDashboard() {
    return this.http.get(`${this.baseURL}/cpm/exportCPMDashboardData`, { observe: 'response', responseType: 'blob'}
    ).pipe(catchError(this.handleError)); 
  }
  private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}

}
